import * as Models from "../.";
export interface ICustomerCreditCheckModel {
  firstName: string;
  middleInitial: string;
  lastName: string;
  dateOfBirth: string;
  phoneNumber: string;
  socialSecurityNumber: string;
  address: Models.Customer.Address.IAddress;
  referenceNumber: string;
  legalNameCorrectlyRepresented: boolean;
  consent: boolean;
}
export class CustomerCreditCheckModel {
  firstName: string;
  middleInitial: string;
  lastName: string;
  dateOfBirth: string;
  phoneNumber: string;
  socialSecurityNumber: string;
  address: Models.Customer.Address.IAddress;
  referenceNumber: string;
  legalNameCorrectlyRepresented: boolean;
  consent: boolean;
}

export interface ICustomerCreditCheckConfirmationResponse {
  creditCheckResponse: Models.Customer.CustomerCreditCheckResponseModel.CustomerCreditCheckResponseModel;
  customerName: string;
  customerReferenceNumber: string;
  address: Models.Customer.Address.IAddress;
  completionTime: Date;
}
